<div class="content d-flex flex-row align-items-center justify-content-between section-title">
  <h2 [style.color]="control.labelColour">{{control.label}}</h2>
  <mat-form-field appearance="fill" color="primary" class="compact" *ngIf="control.showDate">
    <mat-label>Report Date</mat-label>
    <app-mat-date-time-input [enableTime]="false" #dateTimeInputComponent  [(ngModel)]="value" (ngModelChange)="onValueChanges($event)"></app-mat-date-time-input>
    <button mat-icon-button matSuffix (click)="dateTimeInputComponent.togglePicker()"><mat-icon>today</mat-icon></button>
  </mat-form-field>
</div>
